import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import ReturnIcon from '@material-ui/icons/ArrowBack';
import { handleSpecialCharacters } from '../../../../../Utils/Helper';


const styles = theme => ({
  titleHead: {
    backgroundColor: '#F6F6F6',
    flex: '0 0 auto',
  },
  secondToolBar: {
    paddingLeft: '12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '52px'
  },
  searchArea: {
    display: 'flex',
    alignItems: 'inherit'
  },
  formControl: {
    minWidth: '150px'
  },
  searchField: {
    width: '240px',
    marginTop: '16px'
  },
  searchIconMargin: {
    marginRight: '4px'
  },
  button: {
    margin: theme.spacing.unit
  },
  buttonSize: {
    width: '36px',
    height: '36px'
  }
});


class RUTransportsToolbar extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      searchBy: ''
    }
  }

  handleSearch = event => {
    this.setState({ searchBy: handleSpecialCharacters(event.target.value) });
    this.props.reloadTableBySearch(handleSpecialCharacters(event.target.value));
  };
  
  handleClickGoBack() {
    this.props.handleChangeContent('transportsUsedRentals');
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.secondToolBar}>

        <Typography className={classes.titleHead} variant='title' id='transportsTitle'>
          LOTES COM GESTÃO DE TRANSPORTE - RENTING USADOS
        </Typography>

        <div className={classes.searchArea}>
          <FormControl className={classes.formControl}>
            <Grid container spacing={8} alignItems='flex-end'>
              <Grid item>
                <TextField
                  id='search'
                  label=''
                  placeholder='Pesquisar'
                  type='search'
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position='start' className={classes.searchIconMargin}>
                        <SearchIcon />
                      </InputAdornment>
                    )
                  }}
                  className={classes.searchField}
                  value={this.state.searchBy}
                  onChange={this.handleSearch}
                />
              </Grid>
            </Grid>
          </FormControl>
          <Tooltip title='Retroceder' placement='bottom' >
            <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={() => this.handleClickGoBack()} >
              <ReturnIcon />
            </Button>
          </Tooltip>
        </div>

      </div>
    );
  }
};

RUTransportsToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  reloadTableBySearch: PropTypes.func.isRequired
};

export default withStyles(styles)(RUTransportsToolbar);


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsTransport/UsedRentalsByLot/UsedRentalsTable/RUTransportsToolbar.js